import {LoadingButton} from "@mui/lab";
import CircularProgress from "@mui/material/CircularProgress";

const ButtonAdd = ({
                       onClick,
                       text,
                       width = 117,
                       minWidth = width,
                       height = 56,
                       minHeight = height,
                       disabled = false,
                       loading = false,
                       fontSize = "16px",
                       sx: sxProp,
                   }) => {

    return <LoadingButton
        onClick={onClick}
        variant="contained"
        disabled={disabled}
        loading={loading}
        loadingIndicator={<CircularProgress color="inherit" size={height / 2}/>}
        sx={[
            {
                width: width,
                height: height,
                backgroundColor: (theme) => theme.palette.secondary.add,
                borderRadius: "100px",
                boxShadow: "none",
                textTransform: 'none',
                fontSize: fontSize,
                fontWeight: 600,
                '@media (max-width: 1450px)': {
                    width: minWidth,
                    height: minHeight,
                },
                "&:hover": {
                    backgroundColor: (theme) => theme.palette.secondary.add,
                    boxShadow: "none",
                },
            },
            ...(Array.isArray(sxProp) ? sxProp : sxProp ? [sxProp] : []),
        ]}>
        {text}
    </LoadingButton>
}
export default ButtonAdd